import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  createPaymentIntent,
  doCheckOut,
  createWalletPaymentIntent,
  userMetaDetails,
} from "./actions";
import { GetUserById, isGuestOrPremiumUser } from "../settings/actions";
import { getAssessmentAttemptByUserId } from "../dashboard/actions";
import CheckoutC from "./component";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createPaymentIntentConnect: createPaymentIntent,
      doCheckOutConnect: doCheckOut,
      GetUserByIdConnect: GetUserById,
      IsGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      createWalletPaymentIntentConnect: createWalletPaymentIntent,
      userMetaConnect: userMetaDetails,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutC);
